export const environment = {
  production: false,
  apiFormUrl: '/php/misc/function.php',
  apiImageUrl: '/php/cmsImage/function.php',
  imageMiniUrl: '/image/carousel/mini/',
  imageLargeUrl: '/image/carousel/large/',
  analyticsEnabled: false,
};
